<template>
  <v-card class="pa-3" :elevation="is_dialog ? 0 : 5">
    <title-card v-if="!is_dialog"
                text="Trasversalización e Institucionalización"/>
    <v-row class="black--text subtitle-2 ml-3">
      <div v-if="values_ways[0] == 'no'" class="grey--text">
        Sólo mide Institucionalización
      </div>
      <div v-else>
        <span v-for="(way, idx) in ['transver', 'instit']">
          {{`${values_ways[idx]}% de avance en ${idx?'Instituciona':'Transversa'}lización`}}
          <br>
        </span>
      </div>
    </v-row>
  </v-card>
</template>


<script>
import { mapState } from "vuex";
import * as d3 from 'd3';
import homeMixin from "../homeMixin";
import TitleCard from "../common/TitleCard";

export default {
  name: 'InstTranv',
  mixins: [homeMixin],
  components: {
    TitleCard,
  },
  props:{
    ies:{
      type: Object,
      required: false,
    },
    axis:{
      type: Object,
      required: false,
    },
    is_dialog:{
      type: Boolean,
      required: false,
      default: false,
    },    
  },
  data(){
    return {
      building: true,
    }
  },
  computed:{
    ...mapState({
      last_values: state => state.last_values,
      indicadores: state => state.indicadores,
      ejes: state => state.ejes,
    }),
    values_ways(){
      return [this.calcWay('transver'), this.calcWay('instit')]
    },
    dialog_in_ies(){
      return this.$router.currentRoute.name == 'ies'
    }    
  },
  methods: {
    calcWay_(way){
      var mean = d3.mean(this.ejes.filter(eje=>eje.slug!='igualdad'), eje => 
        d3.mean(this.indicadores.filter(ind=>ind[`${way}_weight`]),
          ind=>d3.mean(this.last_values.indicador_values.filter(v=>v.indicador==ind.id), 
            v=>v[`valor_${way}`])/ind[`${way}_weight`])
      )
      return this.format_perc(mean/.01)
    },    
    calcWay(way){
      if (!this.show_charts) return '--'
      //this.dialog_in_ies

      let mean_all = (ejes) => d3.mean(ejes, eje => mean_eje(eje))
      let mean_eje = (eje) => d3.mean(indicadores, ind => mean_indicador(ind))
      let mean_indicador = (ind) => 
        d3.mean(values.filter(v=>v.indicador==ind.id), 
            v=>v[`valor_${way}`])/ind[`${way}_weight`]


      var indicadores = this.indicadores.filter(ind=>
        ind[`${way}_weight`] && (this.axis ? ind.eje==this.axis.id : true))
      if (!indicadores.length) return 'no'

      //var is_ies = (this.dialog_in_ies || this.ies) && !this.axis && !this.is_dialog
      var is_ies = (this.dialog_in_ies || this.ies) && !this.axis && !this.is_dialog
      var values = this[`${is_ies ? 'ies' : 'last_values'}`].indicador_values
      if (this.axis){
        values = values.filter(ind_val=>
          ind_val.eje == this.axis.id 
            && (
              this.ies && !this.dialog_in_ies
                ? ind_val.ies == this.ies.id
                : true))
      }
      else if (this.ies && !this.dialog_in_ies){
        values = values.filter(ind_val=>  ind_val.ies == this.ies.id)
      }
      var final_mean
      if (this.ies && this.is_dialog && this.axis && this.dialog_in_ies){
        values = this.ies.indicador_values.filter(ind_val=>
          ind_val.eje == this.axis.id)
        //values = values.filter(ind_val=> ind_val.ies == this.ies.id)
        //console.log(mean_eje())
        //var curr_inds = values.filter()
        final_mean = d3.mean(values, ind => mean_indicador(ind))
      }
      final_mean = this.axis ? mean_eje(this.axis)
        : mean_all(this.ejes.filter(eje=> eje.slug != 'igualdad'))

      return this.format_perc(final_mean/.01)
    },
  },  
  mounted(){
    //x.color_name = x.color.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
    //str = str.replace(/[\u0300-\u036f]/g, "")
    //str.split(search).join(replacement)
    this.api_url= process.env.VUE_APP_URL
  }
}
</script>

<style lang="scss" scoped>
</style>